


































import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import Vue from 'vue';

export default Vue.extend({
  props: {
    onlyOneChoice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showThisModal: false,
      hasBeenShown: false,
    };
  },
  computed: {
    currLocation(): EstablishmentLocation {
      return this.$store.state.currentLocation;
    },
    takeoutAvailable(): boolean {
      return this.$store.state.takeoutAvailable;
    },
    deliveryAvailable(): boolean {
      return this.$store.state.deliveryAvailable;
    },
    isEmbedded(): boolean {
      return this.$store.state.isEmbedded;
    },
    isDeliveryMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.delivery;
    },
    isTakeoutMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.takeout;
    },
    isTablesideMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.tableside;
    },
  },
  watch: {
    currLocation() {
      this.showThisModalCheck();
    },
  },
  methods: {
    showThisModalCheck() {
      if (this.currLocation && !this.$store.state.stationCode) {
        // So that navigation happens first.
        Vue.nextTick(() => {
          this.$data.showThisModal = true;
        });
      }
    },
    timeSlotsToString(timeSlots: TimeSlot[]) {
      return Util.timeSlotsToString(timeSlots);
    },
  },
});
